/**
 * @file styled components used in BlockWrapper
 */

import styled, { css } from 'styled-components'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'

import { ButtonAddBlock } from '../ButtonAddBlock'

export const DragHandle = styled.div`
  /* position: absolute; */
  /* left: calc(50% - 10px);
  top: 0;
  width: 24px;
  height: 24px;
  opacity: 0;
  cursor: grab; */
`

export const GroupButton = styled.div`
  padding: 5px;
  opacity: 0;
  border-radius: 6px;
  &:hover {
    background-color: ${(p) => p.theme.background._2};
  }
`

export const Spacer = styled.div`
  width: 24px;
  margin-right: 8px;
`

export const BlockMain = styled.div`
  flex: 1;
`

export const Wrapper = styled.div<{ $collapsed: boolean }>`
  display: flex;
  .ant-btn-default {
    min-width: fit-content !important;
  }
  ${({ $collapsed }) =>
    $collapsed &&
    css`
      height: 0;
      overflow: hidden;
    `}

  ${ButtonAddBlock} {
    opacity: 0;

    &:hover {
      opacity: 1;
    }
  }

  &:hover {
    ${GroupButton} {
      opacity: 1;
    }
  }
`

export const BlockContent = styled.div<{
  $highlighted: boolean
  $state: BlockStateEnum
  $borderOnHover: boolean
}>`
  max-width: 862px;
  border-radius: 8px;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
  cursor: ${(props) =>
    props.$state === BlockStateEnum.Editing ? 'default' : 'move'};

  ${({ $borderOnHover, $state }) =>
    $borderOnHover &&
    css`
      &:hover {
        border-color: ${(props) =>
          $state === BlockStateEnum.Editing
            ? 'transparent'
            : props.theme.border.greyLight};

        ${DragHandle} {
          opacity: 1;
        }
      }
    `}

  ${({ $state }) =>
    $state === BlockStateEnum.Selected &&
    css`
      box-shadow: 0px 2px 8px rgba(50, 56, 66, 0.06),
        0px 6px 20px rgba(50, 56, 66, 0.06);
      background-color: ${(props) => props.theme.background._5};
    `}
  

  &&& {
    ${({ $highlighted }) =>
      $highlighted &&
      css`
        background-color: ${(props) => props.theme.brand._5};
      `}
  }
`

export const HighlightBar = styled.div`
  position: absolute;
  width: 6px;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.status.warning.element};
`
